"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.cancelMiniProgramUploadApi = cancelMiniProgramUploadApi;
exports.categoryDeleteApi = categoryDeleteApi;
exports.categoryListApi = categoryListApi;
exports.categorySaveApi = categorySaveApi;
exports.categoryUpdateApi = categoryUpdateApi;
exports.companyDesignListApi = companyDesignListApi;
exports.companyappAutoListApi = companyappAutoListApi;
exports.copyCompany = copyCompany;
exports.createMiniProgramVersionApi = createMiniProgramVersionApi;
exports.customersListApi = customersListApi;
exports.deleteApi = deleteApi;
exports.disableApi = disableApi;
exports.downloadAppApi = downloadAppApi;
exports.enableApi = enableApi;
exports.getBatchListApi = getBatchListApi;
exports.getDeails = getDeails;
exports.getMenuBarApi = getMenuBarApi;
exports.getMiniProgramAuditDetailApi = getMiniProgramAuditDetailApi;
exports.getMiniProgramAuditListApi = getMiniProgramAuditListApi;
exports.getMiniProgramAuditPrepareApi = getMiniProgramAuditPrepareApi;
exports.getMiniProgramPrepareApi = getMiniProgramPrepareApi;
exports.getMiniProgramPublishListApi = getMiniProgramPublishListApi;
exports.getMiniProgramTrialQrcodeApi = getMiniProgramTrialQrcodeApi;
exports.getMiniProgramVersionDetailApi = getMiniProgramVersionDetailApi;
exports.getMiniProgramVersionListApi = getMiniProgramVersionListApi;
exports.getPreviewUrl = getPreviewUrl;
exports.publishMiniProgramAuditApi = publishMiniProgramAuditApi;
exports.removeRelateApi = removeRelateApi;
exports.requestMiniProgramTrialApi = requestMiniProgramTrialApi;
exports.rollbackMiniProgramReleaseApi = rollbackMiniProgramReleaseApi;
exports.saveMenuBarApi = saveMenuBarApi;
exports.setHomepageApi = setHomepageApi;
exports.setVisitorHomepageApi = setVisitorHomepageApi;
exports.speedupMiniProgramAuditApi = speedupMiniProgramAuditApi;
exports.submitMiniProgramAuditApi = submitMiniProgramAuditApi;
exports.submitMiniProgramAuditV2Api = submitMiniProgramAuditV2Api;
exports.submitMiniProgramUploadApi = submitMiniProgramUploadApi;
exports.syncMiniProgramWechatVersionApi = syncMiniProgramWechatVersionApi;
exports.undoMiniProgramAuditApi = undoMiniProgramAuditApi;
exports.updateFuDouStatus = updateFuDouStatus;
exports.updateStatusApi = updateStatusApi;
exports.uploadMiniProgramAuditMediaApi = uploadMiniProgramAuditMediaApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 设为首页
 */
function setHomepageApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/setHomepage",
    method: 'GET',
    params: params
  });
}

/**
 * 设为游客首页
 */
function setVisitorHomepageApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/setVisitorHomepage",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理启用
 */
function enableApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/enable",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理禁用
 */
function disableApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/disable",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理删除
 */
function deleteApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/delete",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理移除共享
 */
function removeRelateApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/removeRelate",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理列表
 */
function companyDesignListApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/list",
    method: 'GET',
    params: params
  });
}

/**
 * 下载小程序
 */
function downloadAppApi(params) {
  return (0, _request.default)({
    url: "/admin/wechat/code/download",
    method: 'GET',
    params: params
  });
}

/**
 * 分支列表
 */
function getBatchListApi() {
  return (0, _request.default)({
    url: "/admin/wechat/code/getBranchList",
    method: 'GET'
  });
}

/**
 * 更新状态
 */
function updateStatusApi(params) {
  return (0, _request.default)({
    url: "/admin/companyapp/updateStatus/".concat(params.status, "/").concat(params.id),
    method: 'GET'
  });
}

/**
 * 客户分类保存
 */

function categorySaveApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/category/save",
    method: 'GET',
    params: params
  });
}

/**
 * 客户分类修改
 */

function categoryUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/customer/category/update",
    method: 'POST',
    data: data
  });
}

/**
 * 客户分类列表
 */

function categoryListApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/category/list",
    method: 'GET',
    params: params
  });
}

/**
 * 客户分类删除
 */

function categoryDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/category/delete",
    method: 'GET',
    params: params
  });
}

/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-app/list",
    method: 'GET',
    params: params
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var originalId = datas.originalId,
    domain = datas.domain,
    appSecret = datas.appSecret,
    messagePushKey = datas.messagePushKey,
    messagePushToken = datas.messagePushToken,
    messagePushEncodingAesKey = datas.messagePushEncodingAesKey,
    ljcName = datas.ljcName,
    appName = datas.appName,
    appLogo = datas.appLogo,
    appId = datas.appId,
    companyId = datas.companyId,
    appColor = datas.appColor,
    customerId = datas.customerId,
    branchName = datas.branchName,
    uniAppId = datas.uniAppId,
    appLoginLogo = datas.appLoginLogo,
    shoppingGuideUrl = datas.shoppingGuideUrl,
    privacyAgreement = datas.privacyAgreement,
    userAgreement = datas.userAgreement,
    fudouCardId = datas.fudouCardId,
    channelId = datas.channelId,
    searchModules = datas.searchModules,
    merchantNo = datas.merchantNo,
    merchantKey = datas.merchantKey,
    certSerialNo = datas.certSerialNo,
    certPath = datas.certPath,
    appQrcodeUrl = datas.appQrcodeUrl,
    payChannel = datas.payChannel;
  return {
    originalId: originalId,
    domain: domain,
    appSecret: appSecret,
    messagePushKey: messagePushKey,
    messagePushToken: messagePushToken,
    messagePushEncodingAesKey: messagePushEncodingAesKey,
    ljcName: ljcName,
    appName: appName,
    appLogo: appLogo,
    appId: appId,
    companyId: companyId,
    appColor: appColor,
    customerId: customerId,
    branchName: branchName,
    uniAppId: uniAppId,
    appLoginLogo: appLoginLogo,
    shoppingGuideUrl: shoppingGuideUrl,
    privacyAgreement: privacyAgreement,
    userAgreement: userAgreement,
    fudouCardId: fudouCardId,
    channelId: channelId,
    searchModules: searchModules,
    merchantNo: merchantNo,
    merchantKey: merchantKey,
    certSerialNo: certSerialNo,
    certPath: certPath,
    appQrcodeUrl: appQrcodeUrl,
    payChannel: payChannel
  };
};

/**
 * 新增
 * @param pram
 * @constructor
 */
function AddArticle(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-app/add',
    method: 'post',
    data: handSubmit(pram)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateArticle(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-app/update',
    method: 'put',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 复制
 */
function copyCompany(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-app/copy',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      oldId: pram.id
    })
  });
}

/**
 * 删除
 * @param id
 * @constructor
 */
function DelArticle(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-app/delete/".concat(id),
    method: 'delete',
    params: {
      id: id
    }
  });
}

/**
 * 获取详情
 * @param {*} id
 * @returns
 */
function getDeails(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-app/detail/".concat(id),
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 查询客户下拉列表
 * @param {*} id
 * @returns
 */
function customersListApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/options",
    method: 'GET',
    params: params
  });
}

/**
 * 获取预览图
 */
function getPreviewUrl(id) {
  return (0, _request.default)({
    url: "/admin/companyapp/getPreviewImg/".concat(id),
    method: 'GET'
  });
}

/**
 * 开启关闭福豆分级
 */
function updateFuDouStatus(status, id) {
  return (0, _request.default)({
    url: "admin/companyapp/updateFuDouStatus/".concat(status, "/").concat(id),
    method: 'GET'
  });
}

/**
 * 小程序列表自动补全（下拉用）
 */
function companyappAutoListApi(params) {
  /*return request({
      url: `/admin/companyapp/autoList`,
      method: 'GET',
      params,
  });*/
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-app/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 菜单栏配置列表
 */
function getMenuBarApi(companyAppId) {
  return (0, _request.default)({
    url: "/admin/appMenuManage/listByCompanyAppId",
    method: 'GET',
    params: {
      companyAppId: companyAppId
    }
  });
}

/**
 * 保存菜单栏配置
 * @param {{ companyAppId: number, list: Array }} data
 */
function saveMenuBarApi(data) {
  return (0, _request.default)({
    url: '/admin/appMenuManage/save',
    method: 'POST',
    data: data
  });
}

/**
 * 获取小程序版本管理初始化信息
 */
function getMiniProgramPrepareApi(companyAppId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/prepare/".concat(companyAppId),
    method: 'GET'
  });
}

/**
 * 创建小程序上传版本
 */
function createMiniProgramVersionApi(data) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/version',
    method: 'POST',
    data: data
  });
}

/**
 * 提交上传版本到Build Runner
 */
function submitMiniProgramUploadApi(versionId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/version/".concat(versionId, "/submit"),
    method: 'POST'
  });
}

/**
 * 中止小程序上传任务
 */
function cancelMiniProgramUploadApi(versionId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/version/".concat(versionId, "/cancel"),
    method: 'POST'
  });
}

/**
 * 将指定草稿上传记录设为体验版
 */
function requestMiniProgramTrialApi(versionId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/version/".concat(versionId, "/trial"),
    method: 'POST'
  });
}

/**
 * 按小程序同步微信侧体验版和线上版本
 */
function syncMiniProgramWechatVersionApi(companyAppId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/version/wechat_sync",
    method: 'POST',
    params: {
      companyAppId: companyAppId
    }
  });
}

/**
 * 获取体验版二维码图片
 */
function getMiniProgramTrialQrcodeApi(versionId, path) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/version/".concat(versionId, "/trial/qrcode"),
    method: 'GET',
    params: path ? {
      path: path
    } : {},
    responseType: 'blob'
  });
}

/**
 * 上传版本列表
 */
function getMiniProgramVersionListApi(params) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/version/list',
    method: 'GET',
    params: params
  });
}

/**
 * 上传版本详情
 */
function getMiniProgramVersionDetailApi(versionId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/version/".concat(versionId),
    method: 'GET'
  });
}

/**
 * 提交微信审核
 */
function submitMiniProgramAuditApi(versionId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/audit/".concat(versionId),
    method: 'POST'
  });
}

/**
 * 获取提交审核所需的体验版页面与已设置类目
 */
function getMiniProgramAuditPrepareApi(companyAppId) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/audit/prepare',
    method: 'GET',
    params: {
      companyAppId: companyAppId
    }
  });
}

/**
 * 上传微信提审预览或反馈素材
 */
function uploadMiniProgramAuditMediaApi(data) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/audit/media_upload',
    method: 'POST',
    data: data
  });
}

/**
 * 提交微信审核
 */
function submitMiniProgramAuditV2Api(data) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/audit/submit',
    method: 'POST',
    data: data
  });
}

/** 实时查看微信审核详情，不更新本地审核记录。 */
function getMiniProgramAuditDetailApi(auditId) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/audit/detail',
    method: 'GET',
    params: {
      auditId: auditId
    }
  });
}
function undoMiniProgramAuditApi(auditId) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/audit/undo',
    method: 'POST',
    data: {
      auditId: auditId
    }
  });
}
function speedupMiniProgramAuditApi(auditId) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$skipGlobalErrorM = _ref.skipGlobalErrorMessage,
    skipGlobalErrorMessage = _ref$skipGlobalErrorM === void 0 ? false : _ref$skipGlobalErrorM;
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/audit/speedup',
    method: 'POST',
    data: {
      auditId: auditId
    },
    __skipGlobalErrorMessage: skipGlobalErrorMessage
  });
}

/**
 * 审核记录列表
 */
function getMiniProgramAuditListApi(params) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/audit/list',
    method: 'GET',
    params: params
  });
}

/**
 * 发布审核通过版本
 */
function publishMiniProgramAuditApi(auditId) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/publish/submit',
    method: 'POST',
    data: {
      auditId: auditId
    }
  });
}
function rollbackMiniProgramReleaseApi(companyAppId) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/publish/rollback',
    method: 'POST',
    data: {
      companyAppId: companyAppId
    }
  });
}

/**
 * 正式发布记录列表
 */
function getMiniProgramPublishListApi(params) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/publish/list',
    method: 'GET',
    params: params
  });
}